import indexMixin from "../mixins/index";
export default {
  name: "res-link",
  mixins: [indexMixin],

  data() {
    return {};
  },

  props: {
    textContent: {
      type: String,
      default: ""
    },
    iconPosition: {
      type: String,
      default: "left" //icon默认位置放在左边

    },
    icon: {
      type: String,
      default: ""
    }
  }
};